module.exports = __webpack_public_path__ + "static/ungroup.bc5d5a0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/learn/ungroup.jpg
// module id = 1174
// module chunks = 127651196306611